<template>
    <b-modal ref="mdlConfigurazioneMagazzinoDocumentoArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Tipo Documento</label>
                <span v-if="isReadOnly"> {{ jsonDataDocumento.codiceTipoDocumento }} </span>
                <b-form-select v-else v-model="jsonDataDocumento.codiceTipoDocumento" :options="tipoDocumentoOptions" :value="''">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Tipo Documento - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Operazione Magazzino</label>
                <span v-if="isReadOnly">{{ formatOperazioneMagazzino(jsonDataDocumento.operazioneMagazzino) }}</span>
                <b-form-select v-else v-model="jsonDataDocumento.operazioneMagazzino" :options="operazioneMagazzinoOptions" :value="null">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Tipo Operazione - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Operazione Contabile</label>
                <span v-if="isReadOnly"> {{ formatOperazioneContabile(jsonDataDocumento.operazioneContabile) }}</span>
                <b-form-select v-else v-model="jsonDataDocumento.operazioneContabile" :options="operazioneContabileOptions" :value="null">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Operazione Contabile - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Descrizione Causale</label>
                <span v-if="isReadOnly"> {{ jsonDataDocumento.descrizioneCausale }}</span>
                <b-form-input v-else v-model="jsonDataDocumento.descrizioneCausale"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Soggetti Collegati</label>
                <span v-if="isReadOnly"> {{ formatSoggettiCollegati(jsonDataDocumento.soggettiCollegati) }}</span>
                <b-form-select v-else v-model="jsonDataDocumento.soggettiCollegati" :options="soggettoCollegatiOptions">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Soggetto - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Stampa Prezzi</label>
                <span v-if="isReadOnly"> {{ formatStampaPrezzo(jsonDataDocumento.stampaPrezzi) }}</span>
                <b-form-checkbox v-else v-model="jsonDataDocumento.stampaPrezzi" switch></b-form-checkbox>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Causale</label>
                <span v-if="isReadOnly"> {{ jsonDataDocumento.codiceCausale }}</span>
                <b-form-input v-else v-model="jsonDataDocumento.codiceCausale"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="6" lg="6" xl="6">
                <label class="sa-label-data">Documenti Collegati</label>
                <span v-if="isReadOnly"> {{ jsonDataDocumento.documentiCollegati }}</span>
                <b-form-input v-else v-model="jsonDataDocumento.documentiCollegati"></b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaDocumento">Salva</b-button>
            <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/causalidocumento",
            pathResourceTipoDocumento: "/tipidocumento",
            isReadOnly: false,
            jsonDataDocumento: {
                id: null,
                codiceTipoDocumento: null,
                operazioneMagazzino: null,
                operazioneContabile: null,
                descrizioneCausale: null,
                stampaPrezzi: false,
                soggettiCollegati: null,
                documentiCollegati: null,
            },
            operazioneContabileOptions: [
                {
                    text: "Dare",
                    value: 1,
                    // value: "Dare",
                },
                {
                    text: "Avere",
                    value: -1,
                    // value: "Avere",
                },
                {
                    text: "Invariato",
                    value: 0,
                    // value: "Invariato",
                },
            ],
            tipoDocumentoOptions: [],
            soggettoCollegatiOptions: [
                {
                    text: "Cliente",
                    value: "CL",
                },
                {
                    text: "Fornitore",
                    value: "FOR",
                },
                {
                    text: "Entrambi",
                    value: "TTT",
                },
            ],
            operazioneMagazzinoOptions: [
                {
                    text: "Scarico",
                    value: -1,
                },
                {
                    text: "Carico",
                    value: 1,
                },
                {
                    text: "Invariato",
                    value: 0,
                },
            ],
        };
    },
    mounted() {
        let me = this;
        me.loadDataTipoDocumento();
        console.log("Componente attivo");
    },
    methods: {
        //=================READ===================
        loadDataTipoDocumento() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTipoDocumento, null, me.loadDataTipoDocumentoSuccess, me.loadDataTipoDocumentoError);
        },
        loadDataTipoDocumentoSuccess(response) {
            let me = this;
            console.log(response);
            me.tipoDocumentoOptions = response.data.data.map((item) => ({
                value: item.codiceTipoDocumento,
                text: item.descrizioneTipoDocumento,
            }));
        },
        loadDataTipoDocumentoError(response) {
            console.log(response);
        },
        show(jsonDataDocumento, isReadOnly) {
            let me = this;
            me.jsonDataDocumento = jsonDataDocumento;
            me.isReadOnly = isReadOnly;

            if (isReadOnly) {
                me.title = "Visualizzazione Documento";
            } else {
                me.title = !jsonDataDocumento.id ? "Nuova Documento" : "Aggiorna Documento";
            }

            me.$refs.mdlConfigurazioneMagazzinoDocumentoArticoli.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonDataDocumento = {};
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioneMagazzinoDocumentoArticoli.hide();
        },
        onClickSalvaDocumento() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataDocumento, me.salvaDocumentoArticoloSuccess, me.salvaDocumentoArticoloError);
            console.log("Json", me.jsonDataDocumento);
        },
        salvaDocumentoArticoloSuccess(response) {
            let me = this;
            me.$emit("saveDocumentoArticolo", response);
            me.$refs.mdlConfigurazioneMagazzinoDocumentoArticoli.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        salvaDocumentoArticoloError(error) {
            let me = this;
            me.$emit("saveDocumentoArticolo", error);
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onDeleteDocumentoArticolo(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo documento?", {
                    title: "Eliminazione Documento",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteDocumentoArticolo(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteDocumentoArticolo(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteDocumentoArticoloSuccess, me.deleteDocumentoArticoloError);
        },
        deleteDocumentoArticoloSuccess(response) {
            let me = this;
            me.$emit("documentoArticoloDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteDocumentoArticoloError(response) {
            let me = this;
            me.$emit("documentoArticoloDelete", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        formatOperazioneMagazzino(value) {
            switch (value) {
                case 1:
                    return "Carico";
                case -1:
                    return "Scarico";
                case 0:
                    return "Invariato";
                default:
                    return "N/A";
            }
        },

        formatOperazioneContabile(value) {
            switch (value) {
                case 1:
                    return "Dare";
                case -1:
                    return "Avere";
                case 0:
                    return "Invariato";
                default:
                    return "N/A";
            }
        },

        formatStampaPrezzo(value) {
            switch (value) {
                case true:
                    return "Sì";
                case false:
                    return "No";
                default:
                    return value || "N/A";
            }
        },
        formatSoggettiCollegati(value) {
            switch (value) {
                case "CL":
                    return "Cliente";
                case "FOR":
                    return "Fornitore";
                case "TTT":
                    return "Entrambi";
                default:
                    return value || "N/A";
            }
        },
    },
};
</script>
